import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs'; import DatePicker, { registerLocale } from "react-datepicker";
import { de } from "date-fns/locale";
import { subYears, format, parse, isValid } from "date-fns";
import { Turnstile } from "@marsidev/react-turnstile";

const InternerWohnungsStepform = () => {

    const [step, setStep] = useState(1);

    useEffect(() => {
        $(".select2").select2();
    }, []);


    const navigate = useNavigate();


    const [formData, setFormData] = useState({
        cityLocation: "",
        rooms: "",
        stockwerk: "",
        rent: "",
        moveIn: "",
        tenants: "",
        adults: "",
        children: "",
        parking: "",
        vehicles: [],
        pets: "",
        message: "",
    });

    const initialTenant = {
        anrede: "",
        vorname: "",
        nachname: "",
        geburtsdatum: "",
        adresse: "",
        plz: "",
        ort: "",
        telefonPrivat: "",
        telefonGeschaft: "",
        email: "",
        income: "",
    };

    const [mieters, setMieters] = useState([initialTenant]);


    // ================= HANDLE FORM =================

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleVehicleChange = (index, field, value) => {
        setFormData((prev) => {
            const updatedVehicles = [...prev.vehicles];

            updatedVehicles[index] = {
                ...updatedVehicles[index],
                [field]: value,
            };

            return {
                ...prev,
                vehicles: updatedVehicles,
            };
        });

        setErrors((prev) => ({
            ...prev,
            [`vehicle-${index}-${field}`]: false,
        }));
    };


    // ================= HANDLE MIETER =================

    const handleMieterChange = (index, e) => {
        const { name, value } = e.target;

        const updated = [...mieters];

        updated[index][name] = value;

        setMieters(updated);

        // REMOVE ERROR ON CHANGE
        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`mieter-${index}-${name}`];
            return newErrors;
        });
    };


    // ================= ADD MIETER =================

    const handleAddMieter = () => {
        if (mieters.length >= 2) return;

        setMieters((prev) => [...prev, initialTenant]);
    };

    const handleRemoveMieter = () => {
        if (mieters.length <= 1) return;

        setMieters((prev) => prev.slice(0, -1));
    };


    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");

                // FOR MAIN FORM
                if (name === "parking") {
                    let count = 0;

                    if (value === "1 Fahrzeug") count = 1;
                    if (value === "2 Fahrzeuge") count = 2;
                    if (value === "3 Fahrzeuge oder mehr") count = 3;

                    setFormData((prev) => ({
                        ...prev,
                        parking: value,
                        vehicles:
                            value === "Keine"
                                ? []
                                : Array.from({ length: count }, (_, index) => ({
                                    fahrzeugart:
                                        prev.vehicles?.[index]?.fahrzeugart || "",
                                    parkplatz:
                                        prev.vehicles?.[index]?.parkplatz || "Nein",
                                })),
                    }));
                }
                else if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }

                // FOR MIETERS
                if (name === "anrede") {
                    const index = $(".select2[name='anrede']").index(this);

                    console.log("Mieter index:", index, name, value);

                    setMieters((prev) => {
                        const updated = [...prev];
                        updated[index].anrede = value;
                        return updated;
                    });
                }
            });
        });

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, [mieters, step]);

    useEffect(() => {
        const $fahrzeugart = $("select[name='fahrzeugart']");

        $fahrzeugart.each(function () {
            const $el = $(this);

            if ($el.data("select2")) {
                $el.select2("destroy");
            }

            $el.select2();

            $el.off("change.fahrzeugart").on("change.fahrzeugart", function () {
                const index = Number($(this).data("index"));
                const value = $(this).val();

                setFormData((prev) => {
                    const vehicles = [...prev.vehicles];

                    vehicles[index] = {
                        ...vehicles[index],
                        fahrzeugart: value,
                    };

                    return {
                        ...prev,
                        vehicles,
                    };
                });
            });
        });

        return () => {
            $fahrzeugart.each(function () {
                const $el = $(this);

                if ($el.data("select2")) {
                    $el.select2("destroy");
                }
            });
        };
    }, [formData.vehicles.length]);


    const [errors, setErrors] = useState({});

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const validateForm = () => {
        let newErrors = {};

        // MAIN FORM REQUIRED FIELDS
        const requiredFields = [
            "cityLocation",
            "rooms",
            "rent",
            "moveIn",
            "tenants",
            "adults",
            "children",
            "parking",
        ];

        if (formData.parking !== "Keine") {
            formData.vehicles.forEach((vehicle, index) => {
                if (!vehicle.fahrzeugart) {
                    newErrors[`vehicle-${index}-fahrzeugart`] = true;
                }

                if (!vehicle.parkplatz) {
                    newErrors[`vehicle-${index}-parkplatz`] = true;
                }
            });
        }

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        if (formData.moveIn) {
            const error = getMoveInError(formData.moveIn);

            if (error) {
                newErrors.moveIn = error;
            }
        }

        // MIETERS REQUIRED FIELDS
        mieters.forEach((mieter, index) => {
            const requiredMieterFields = [
                "anrede",
                "vorname",
                "nachname",
                "geburtsdatum",
                "adresse",
                "plz",
                "ort",
                "telefonPrivat",
                "email",
            ];

            requiredMieterFields.forEach((field) => {
                if (!mieter[field] || mieter[field].trim() === "") {
                    newErrors[`mieter-${index}-${field}`] = true;
                }
            });

            if (
                mieter.email &&
                !isValidEmail(mieter.email)
            ) {
                newErrors[`mieter-${index}-email`] = true;
            }
            if (mieter.geburtsdatum) {
                const error = getBirthDateError(mieter.geburtsdatum);

                if (error) {
                    newErrors[`mieter-${index}-geburtsdatum`] = error;
                }
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ================= SUBMIT =================
    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);


    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateForm();

        if (!isValid) {

            setTimeout(() => {
                document.querySelectorAll(".warning-border").forEach((el) => {
                    el.classList.remove("shake");

                    // restart animation
                    void el.offsetWidth;

                    el.classList.add("shake");
                });
            }, 0);

            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        const payload = {
            ...formData,
            mieters,
        };

        console.log(payload);

        const customTitle = "Interner Wohnungswechsel"

        try {
            // API CALL HERE
            setIsSubmitting(true);

            const response = await fetch(`${process.env.REACT_APP_FRONTEND_URL}api/submit-interner-wohnungswechsel-form?pageTitle=${customTitle}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            console.log("Form submission response:", data);

            if (data?.success) {
                navigate("/vielen-dank");
            }

            // alert("Form submitted successfully!");
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            let hasError = false;

            if (name === "anrede") {
                const index = $(".select2[name='anrede']").index(this);

                hasError = !!errors[`mieter-${index}-anrede`] && mieters[index].anrede?.trim() === "";
            } else {
                hasError = !!errors[name] && formData[name]?.trim() === "";
            }

            if (hasError) {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border shake");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");
            }
        });
    }, [errors]);

    const validateCurrentStep = () => {
        let newErrors = {};

        if (step === 1) {
            const requiredFields = [
                "cityLocation",
                "rooms",
                "rent",
                "moveIn",
                "tenants",
                "adults",
                "children",
            ];

            requiredFields.forEach((field) => {
                if (!formData[field] || formData[field].trim() === "") {
                    newErrors[field] = true;
                }
            });

            if (formData.moveIn) {
                const error = getMoveInError(formData.moveIn);

                if (error) {
                    newErrors.moveIn = error;
                }
            }
        }

        if (step === 2) {
            mieters.forEach((mieter, index) => {
                const requiredMieterFields = [
                    "anrede",
                    "vorname",
                    "nachname",
                    "geburtsdatum",
                    "adresse",
                    "plz",
                    "ort",
                    "telefonPrivat",
                    "email",
                ];

                requiredMieterFields.forEach((field) => {
                    if (!mieter[field] || mieter[field].trim() === "") {
                        newErrors[`mieter-${index}-${field}`] = true;
                    }
                });

                if (
                    mieter.email &&
                    !isValidEmail(mieter.email)
                ) {
                    newErrors[`mieter-${index}-email`] = true;
                }
                if (mieter.geburtsdatum) {
                    const error = getBirthDateError(mieter.geburtsdatum);

                    if (error) {
                        newErrors[`mieter-${index}-geburtsdatum`] = error;
                    }
                }
            });
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const nextStep = (e) => {
        e.preventDefault();

        const isValid = validateCurrentStep();

        if (!isValid) {
            setTimeout(() => {
                document.querySelectorAll(".warning-border").forEach((el) => {
                    el.classList.remove("shake");
                    void el.offsetWidth; // restart animation
                    el.classList.add("shake");
                });
            }, 0);

            return;
        }

        setStep((prev) => prev + 1);
    };

    const prevStep = (e) => {
        e.preventDefault();
        setStep((prev) => prev - 1);
    };

    useEffect(() => {
        if (window.innerWidth >= 480) return;

        const element = document.getElementById("step-form-id");

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [step]);


    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 600);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getMoveInError = (value) => {
        if (!value) return "";

        const regex = /^(\d{2})\.(\d{2})\.(\d{4})$/;

        if (!regex.test(value))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const parsed = parse(value, "dd.MM.yyyy", new Date());

        if (!isValid(parsed))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        if (format(parsed, "dd.MM.yyyy") !== value)
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        parsed.setHours(0, 0, 0, 0);

        if (parsed < today)
            return "Das Einzugsdatum muss in der Zukunft liegen";

        return "";
    };

    const getBirthDateError = (value) => {
        if (!value) return "";

        const regex = /^(\d{2})\.(\d{2})\.(\d{4})$/;

        if (!regex.test(value))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const parsed = parse(value, "dd.MM.yyyy", new Date());

        if (!isValid(parsed))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        if (format(parsed, "dd.MM.yyyy") !== value)
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const minBirthDate = subYears(new Date(), 18);

        if (parsed > minBirthDate)
            return "Sie müssen mindestens 18 Jahre alt sein";

        return "";
    };

    return (
        <div className="pt-10">
            <div className="row" id="step-form-id">
                {/* Steps */}
                <div className="col-md-4 mb-4">
                    <div className="step-sidebar">
                        {[1, 2, 3].map((item) => (
                            <div key={item} className={`step-item ${step >= item ? "active" : ""}`} style={{ color: step == item ? 'var(--orange)' : 'unset' }}>
                                <h3 className="fs_30 fw-600 mb-0">
                                    {item === 1 && "Gewünschte Wohnung"}
                                    {item === 2 && "Persönliche Angaben"}
                                    {item === 3 && "Allgemeine Informationen"}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
                {/* Form Content */}
                <div className="col-md-8">
                    <form onSubmit={handleSubmit}>
                        <div className="step-form-wraper p-md-4">
                            {step === 1 && (
                                <>
                                    <div className='sec-title'>
                                        <h2 className="title-line-before text-darkgrey mb-4">Ihre gewünschte Wohnung</h2>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <select
                                                className={`form-control select2`}
                                                name="cityLocation"
                                                value={formData.cityLocation}
                                            >
                                                <option value="" className="placeholder" disabled>
                                                    Kreis / Ort *
                                                </option>

                                                <option value="Albisrieden (Kreis 9)">
                                                    Albisrieden (Kreis 9)
                                                </option>

                                                <option value="Altstetten (Kreis 9)">
                                                    Altstetten (Kreis 9)
                                                </option>

                                                <option value="Aussersihl (Kreis 4)">
                                                    Aussersihl (Kreis 4)
                                                </option>

                                                <option value="Höngg (Kreis 10)">
                                                    Höngg (Kreis 10)
                                                </option>

                                                <option value="Leimbach (Kreis 2)">
                                                    Leimbach (Kreis 2)
                                                </option>

                                                <option value="Wiedikon (Kreis 3)">
                                                    Wiedikon (Kreis 3)
                                                </option>

                                                <option value="Wipkingen (Kreis 10)">
                                                    Wipkingen (Kreis 10)
                                                </option>

                                                <option value="Wollishofen">
                                                    Wollishofen
                                                </option>

                                                <option value="Adliswil">
                                                    Adliswil
                                                </option>

                                                <option value="Feldmeilen">
                                                    Feldmeilen
                                                </option>

                                                <option value="Gattikon">
                                                    Gattikon
                                                </option>

                                                <option value="Horgen">
                                                    Horgen
                                                </option>

                                                <option value="Küsnacht">
                                                    Küsnacht
                                                </option>

                                                <option value="Langnau am Albis">
                                                    Langnau am Albis
                                                </option>

                                                <option value="Meilen">
                                                    Meilen
                                                </option>

                                                <option value="Oberrieden">
                                                    Oberrieden
                                                </option>

                                                <option value="Thalwil">
                                                    Thalwil
                                                </option>

                                                <option value="Ganze Stadt Zürich">
                                                    Ganze Stadt Zürich
                                                </option>

                                                <option value="Ganzer Kanton Zürich">
                                                    Ganzer Kanton Zürich
                                                </option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <select
                                                className="form-control select2"
                                                name="rooms"
                                                value={formData.rooms}
                                            >
                                                <option value="" className="placeholder" disabled>
                                                    Anzahl Zimmer *
                                                </option>

                                                <option value="1-2 Zimmer">
                                                    1-2 Zimmer
                                                </option>

                                                <option value="3 Zimmer">
                                                    3 Zimmer
                                                </option>

                                                <option value="4 Zimmer">
                                                    4 Zimmer
                                                </option>

                                                <option value="5 Zimmer">
                                                    5 Zimmer
                                                </option>

                                                <option value="mehr als 5 Zimmer">
                                                    mehr als 5 Zimmer
                                                </option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Stockwerk"
                                                name="stockwerk"
                                                value={formData.stockwerk}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <select
                                                className="form-control select2"
                                                name="rent"
                                                value={formData.rent}
                                            >
                                                <option value="" className='placeholder' disabled>
                                                    Höchstmiete *
                                                </option>

                                                <option value="bis CHF 1'000">bis CHF 1'000</option>
                                                <option value="bis CHF 1'500">bis CHF 1'500</option>
                                                <option value="bis CHF 2'000">bis CHF 2'000</option>
                                                <option value="bis CHF 2'500">bis CHF 2'500</option>
                                                <option value="bis CHF 3'000">bis CHF 3'000</option>
                                                <option value="bis CHF 3'500">bis CHF 3'500</option>
                                                <option value="über CHF 3'500">über CHF 3'500</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 form-group position-relative">
                                            {!isMobile ? (
                                                <DatePicker
                                                    selected={
                                                        formData.moveIn
                                                            ? parse(formData.moveIn, "dd.MM.yyyy", new Date())
                                                            : null
                                                    }
                                                    onChange={(date) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            moveIn: date ? format(date, "dd.MM.yyyy") : "",
                                                        }));

                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            moveIn: false,
                                                        }));
                                                    }}
                                                    locale="de"
                                                    dateFormat="dd.MM.yyyy"
                                                    placeholderText="Einzug per *"
                                                    className={`form-control ${errors.moveIn ? "warning-border shake" : ""}`}
                                                    isClearable
                                                    minDate={new Date()}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="Einzug per *"
                                                    value={formData.moveIn}
                                                    className={`form-control ${errors.moveIn ? "warning-border shake" : ""}`}
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        let value = e.target.value.replace(/\D/g, "");

                                                        if (value.length > 2)
                                                            value = value.slice(0, 2) + "." + value.slice(2);

                                                        if (value.length > 5)
                                                            value = value.slice(0, 5) + "." + value.slice(5);

                                                        if (value.length > 10)
                                                            value = value.slice(0, 10);

                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            moveIn: value,
                                                        }));
                                                    }}
                                                />
                                            )}
                                            {!formData.moveIn && <img className='calender-icon' src="images/calender-icon-bgz2.svg" alt="" />}
                                            {errors.moveIn && (
                                                <small className="" style={{ color: "var(--orange)" }}>
                                                    {errors.moveIn}
                                                </small>
                                            )}
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <select
                                                className="form-control select2"
                                                name="tenants"
                                                value={formData.tenants}
                                            >
                                                <option value="" className="placeholder" disabled>
                                                    Anzahl Mieter *
                                                </option>

                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <select
                                                className="form-control select2"
                                                name="adults"
                                                value={formData.adults}
                                            >
                                                <option value="" className="placeholder" disabled>
                                                    Anzahl erwachsene Personen *
                                                </option>

                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </div>

                                        <div className="col-md-6 form-group">
                                            <select
                                                className="form-control select2"
                                                name="children"
                                                value={formData.children}
                                            >
                                                <option value="" className="placeholder" disabled>
                                                    Anzahl Kinder *
                                                </option>

                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="Keine">Keine</option>
                                            </select>
                                        </div>
                                    </div>
                                </>
                            )}
                            {step === 2 && (
                                <>
                                    <div className='sec-title'>
                                        <h2 className="title-line-before text-darkgrey mb-4">Ihre persönlichen Angaben</h2>
                                    </div>
                                    {mieters.map((mieter, index) => (
                                        <div className={`meiter_wrapper ${mieters?.length > 1 && index === 0 ? "mb-4" : ""}`} key={index}>
                                            <div className="d-flex align-items-center justify-content-between mb-4">
                                                <h4 className="fw-450 text-darkgrey mb-0">
                                                    Mieter {index + 1}
                                                </h4>
                                                {index > 0 && <button type='button' onClick={handleRemoveMieter} style={{ width: '35px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" nighteye="disabled">
                                                        <rect width="64" height="64" rx="32" fill={`var(--orange)`} />
                                                        <rect x="19.3203" y="21.1396" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 19.3203 21.1396)" fill="white" />
                                                        <rect x="42.8594" y="19.3301" width="2.56" height="33.28" rx="1.28" transform="rotate(45 42.8594 19.3301)" fill="white" />
                                                    </svg>
                                                </button>}
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-12 form-group">
                                                    <select
                                                        className="form-control select2"
                                                        name="anrede"
                                                        value={mieter.anrede}
                                                    >
                                                        <option value="" disabled>
                                                            Anrede *
                                                        </option>

                                                        <option value="Frau">Frau</option>
                                                        <option value="Herr">Herr</option>
                                                    </select>
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-vorname`] ? "warning-border shake" : ""}`}
                                                        placeholder="Vorname *"
                                                        name="vorname"
                                                        value={mieter.vorname}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-nachname`] ? "warning-border shake" : ""}`}
                                                        placeholder="Nachname *"
                                                        name="nachname"
                                                        value={mieter.nachname}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group position-relative">
                                                    {!isMobile ? (
                                                        <DatePicker
                                                            selected={
                                                                mieter.geburtsdatum
                                                                    ? parse(mieter.geburtsdatum, "dd.MM.yyyy", new Date())
                                                                    : null
                                                            }
                                                            onChange={(date) => {
                                                                const updated = [...mieters];

                                                                updated[index].geburtsdatum = date
                                                                    ? format(date, "dd.MM.yyyy")
                                                                    : "";

                                                                setMieters(updated);

                                                                setErrors((prev) => ({
                                                                    ...prev,
                                                                    [`mieter-${index}-geburtsdatum`]: false,
                                                                }));
                                                            }}
                                                            locale="de"
                                                            dateFormat="dd.MM.yyyy"
                                                            placeholderText="Geburtsdatum *"
                                                            className={`form-control ${errors[`mieter-${index}-geburtsdatum`] ? "warning-border shake" : ""}`}
                                                            isClearable
                                                            maxDate={subYears(new Date(), 18)}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            placeholder="Geburtsdatum *"
                                                            value={mieter.geburtsdatum}
                                                            className={`form-control ${errors[`mieter-${index}-geburtsdatum`] ? "warning-border shake" : ""}`}
                                                            maxLength={10}
                                                            onChange={(e) => {
                                                                let value = e.target.value.replace(/\D/g, "");

                                                                if (value.length > 2)
                                                                    value = value.slice(0, 2) + "." + value.slice(2);

                                                                if (value.length > 5)
                                                                    value = value.slice(0, 5) + "." + value.slice(5);

                                                                if (value.length > 10)
                                                                    value = value.slice(0, 10);

                                                                const updated = [...mieters];
                                                                updated[index].geburtsdatum = value;

                                                                setMieters(updated);

                                                                setErrors((prev) => ({
                                                                    ...prev,
                                                                    [`mieter-${index}-geburtsdatum`]: false,
                                                                }));
                                                            }}
                                                        />
                                                    )}
                                                    {!mieter.geburtsdatum && <img className='calender-icon' src="images/calender-icon-bgz2.svg" alt="" />}
                                                    {errors[`mieter-${index}-geburtsdatum`] && (
                                                        <small className="" style={{ color: "var(--orange)" }}>
                                                            {errors[`mieter-${index}-geburtsdatum`]}
                                                        </small>
                                                    )}
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-adresse`] ? "warning-border shake" : ""}`}
                                                        placeholder="Strasse + Nr. *"
                                                        name="adresse"
                                                        value={mieter.adresse}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-plz`] ? "warning-border shake" : ""}`}
                                                        placeholder="PLZ *"
                                                        name="plz"
                                                        value={mieter.plz}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-ort`] ? "warning-border shake" : ""}`}
                                                        placeholder="Ort *"
                                                        name="ort"
                                                        value={mieter.ort}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-telefonPrivat`] ? "warning-border shake" : ""}`}
                                                        placeholder="Telefon Privat *"
                                                        name="telefonPrivat"
                                                        value={mieter.telefonPrivat}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/[^0-9+\s()-]/g, "");

                                                            handleMieterChange(index, {
                                                                target: {
                                                                    name: "telefonPrivat",
                                                                    value,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors[`mieter-${index}-telefonGeschaft`] ? "warning-border shake" : ""}`}
                                                        placeholder="Telefon Geschäft"
                                                        name="telefonGeschaft"
                                                        value={mieter.telefonGeschaft}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/[^0-9+\s()-]/g, "");

                                                            handleMieterChange(index, {
                                                                target: {
                                                                    name: "telefonGeschaft",
                                                                    value,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="email"
                                                        className={`form-control ${errors[`mieter-${index}-email`] ? "warning-border shake" : ""}`}
                                                        placeholder="E-Mail *"
                                                        name="email"
                                                        value={mieter.email}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>

                                                <div className="col-sm-6 form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Bruttojahreseinkommen (CHF)"
                                                        name="income"
                                                        value={mieter.income}
                                                        onChange={(e) =>
                                                            handleMieterChange(index, e)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {mieters.length < 2 && <button
                                        type="button"
                                        className="simple-add-btn"
                                        onClick={handleAddMieter}
                                        disabled={mieters.length >= 2}
                                    >
                                        <span>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="7.19922" width="1.2" height="15.6" rx="0.6" fill="white" />
                                                <rect x="15.5996" y="7.19922" width="1.2" height="15.6" rx="0.6" transform="rotate(90 15.5996 7.19922)" fill="white" />
                                            </svg>
                                        </span>Mieter hinzufügen
                                    </button>}
                                </>
                            )}
                            {step === 3 && (
                                <>
                                    <div className='sec-title'>
                                        <h2 className="title-line-before text-darkgrey mb-4">Allgemeine Informationen</h2>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-12 form-group'>
                                            <select
                                                className="form-control select2"
                                                name="parking"
                                                value={formData.parking}
                                            >
                                                <option value="" disabled>
                                                    Wie viele Parkplätze benötigen Sie? Anzahl Fahrzeuge*
                                                </option>

                                                <option value="1 Fahrzeug">
                                                    1 Fahrzeug
                                                </option>

                                                <option value="2 Fahrzeuge">
                                                    2 Fahrzeuge
                                                </option>

                                                <option value="3 Fahrzeuge oder mehr">
                                                    3 Fahrzeuge oder mehr
                                                </option>

                                                <option value="Keine">
                                                    Keine
                                                </option>
                                            </select>
                                        </div>
                                        {formData.vehicles?.map((vehicle, index) => (
                                            <React.Fragment key={index}>
                                                <div className="col-sm-6 form-group">
                                                    <label className="mb-2" style={{ fontSize: 'var(--fs20)' }}>
                                                        Fahrzeugart {index + 1} *
                                                    </label>

                                                    <select
                                                        className="form-control select2"
                                                        name="fahrzeugart"
                                                        data-index={index}
                                                        value={vehicle.fahrzeugart}
                                                    >
                                                        <option value="">Bitte wählen</option>
                                                        <option value="Auto">Auto</option>
                                                        <option value="Motorrad">Motorrad</option>
                                                    </select>
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <label className="mb-2" style={{ fontSize: 'var(--fs20)' }}>
                                                        Parkplatz {index + 1} *
                                                    </label>

                                                    <div className="radio-group">
                                                        <label className="radio-item">
                                                            <input
                                                                type="radio"
                                                                name={`parkplatz-${index}`}
                                                                checked={vehicle.parkplatz === "Nein"}
                                                                onChange={() =>
                                                                    handleVehicleChange(
                                                                        index,
                                                                        "parkplatz",
                                                                        "Nein"
                                                                    )
                                                                }
                                                            />
                                                            <span className="custom-radio"></span>
                                                            Nein
                                                        </label>

                                                        <label className="radio-item">
                                                            <input
                                                                type="radio"
                                                                name={`parkplatz-${index}`}
                                                                checked={vehicle.parkplatz === "Ja"}
                                                                onChange={() =>
                                                                    handleVehicleChange(
                                                                        index,
                                                                        "parkplatz",
                                                                        "Ja"
                                                                    )
                                                                }
                                                            />
                                                            <span className="custom-radio"></span>
                                                            Ja
                                                        </label>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                        <div className='col-sm-12 form-group'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Besitzen Sie Haustiere? Wenn ja, welche/s?"
                                                name="pets"
                                                value={formData.pets}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className='col-sm-12 form-group'>
                                            <textarea
                                                rows={5}
                                                className="form-control"
                                                placeholder="Ihre Mitteilung"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-captcha'>
                                            <div className='google_recaptcha'>
                                                <Turnstile
                                                    siteKey="0x4AAAAAADt5N15MzxPtrdSe"
                                                    onSuccess={(token) => {
                                                        setCaptchaToken(token);
                                                        setCaptchaError(false);
                                                    }}
                                                    onExpire={() => {
                                                        setCaptchaToken("");
                                                    }}
                                                />

                                                {captchaError && (
                                                    <p
                                                        style={{
                                                            color: "red",
                                                            marginTop: "10px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        Bitte bestätigen Sie das Captcha.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className={`d-flex ${step === 1 ? 'justify-content-end' : 'justify-content-between'} mt-4`}>
                                <button type="button" className={`step_back_btn ${step === 1 ? 'd-none' : ''}`} onClick={prevStep} disabled={step === 1}>
                                    <svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.7369 0.311788C11.1725 -0.103929 11.8787 -0.103924 12.3143 0.311788C12.7499 0.727507 12.7499 1.40153 12.3143 1.81725L2.69274 11L12.3143 20.1828C12.7499 20.5985 12.7499 21.2725 12.3143 21.6882C11.8787 22.1039 11.1725 22.1039 10.7369 21.6882L0.326683 11.7527C-0.108895 11.337 -0.108899 10.663 0.326683 10.2473L10.7369 0.311788Z" fill="#F18300" />
                                        <path d="M27.8846 9.93548C28.5006 9.93548 29 10.4121 29 11C29 11.5879 28.5006 12.0645 27.8846 12.0645L1.11538 12.0645C0.499373 12.0645 -2.02077e-06 11.5879 -1.91798e-06 11C-1.81518e-06 10.4121 0.499373 9.93548 1.11538 9.93548L27.8846 9.93548Z" fill="#F18300" />
                                    </svg>
                                    zurück </button>
                                {step < 3 ? (
                                    <button type="button" className="button round_btn btn-orange-color" onClick={nextStep}> weiter
                                        <span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit"></path><path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit"></path></svg></span>
                                    </button>
                                ) : (
                                    <button type="submit" className="button round_btn btn-orange-color"> absenden
                                        <span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit"></path><path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit"></path></svg></span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default InternerWohnungsStepform;